import { useSelector } from 'react-redux';
import './RegistrationFail.scss'
import Table from 'react-bootstrap/esm/Table';

const RegistrationFail = ({ message, clearErrorBox }: {message: string; clearErrorBox: (msg: any) => void}) => {
  const admissionDescription = useSelector((state: any) => state?.admissionSettings?.description);
  return (
    <div className="aptitude-details my-5 pt-5">
  <div className="d-flex align-item-center">
    <div className="container">
      <div className="row">
        <div className="col-md-8 offset-md-2">

          {/* Card: Added shadow, removed border, and added overflow-hidden to clip corners */}
          <div className="card border-0 shadow-lg rounded-3 overflow-hidden">
            <div className="table-responsive">

              {/* Table: Added 'table-borderless' to remove grid lines */}
              <Table className="table table-borderless mb-0">
                <tbody>
                  <tr className='border-bottom border-danger bg='>
                    <td colSpan={2} className="p-0">
                      {/* Header: Changed to white bg with green text */}
                      <div className="card-header bg-danger text-center border-0 py-4">
                        <h3 className="text-white font-weight-bold aptitude-title mb-0">
                          {admissionDescription} Candidate Application Status
                        </h3>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colSpan={2}>
                      <div className="d-flex justify-content-center align-item-center py-5">
                        <div className="text-center w-75">
                          {/* Message: Added distinct styling for readability */}
                          <div
                            style={{ fontSize: '1.25rem', lineHeight: '1.6' }}
                            className="text-muted"
                            dangerouslySetInnerHTML={{ __html: message }}
                          ></div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td className="text-center close-col pb-4 px-5" colSpan={2}>
                      {/* Button: Modern Green Style */}
                      <button
                        onClick={clearErrorBox}
                        className="btn btn-danger text-white shadow-sm btn-block py-3 font-weight-bold"
                        style={{ borderRadius: '10px', fontSize: '1rem' }}
                      >
                        Close
                      </button>
                    </td>
                  </tr>

                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  )
}

export default RegistrationFail
